import { useJoinUsApi } from '../../hooks/useJoinUsApi';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

type JoinUsParams = {
  page?: number;
  limit?: number;
  search?: string;
  type?: 'Rider' | 'Partner';
  sortBy?: 'name' | 'email' | 'phone' | 'type' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
};

export const useGetAllJoinUs = (queryParams: JoinUsParams, options?: Omit<UseQueryOptions<any, Error>, 'queryKey' | 'queryFn'>) => {
  const { getAllJoinUs } = useJoinUsApi();

  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getJoinUs', queryParams],
    queryFn: () => {
      return getAllJoinUs({
        page: queryParams.page || 1,
        limit: queryParams.limit || 10,
        search: queryParams.search,
        type: queryParams.type,
        sortBy: queryParams.sortBy || 'createdAt',
        sortOrder: queryParams.sortOrder || 'desc',
      });
    },
    ...options,
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};